<template>
  <div class="news-list list-box">
      <div class="title">
        <span></span>
        <h3>Latest news</h3>
      </div>
      <div v-if="hotNewList.length">
        <div v-for="(item,index) in hotNewList.slice(0,5)" :key="index" @click="linkToNews(item)" class="list-info">
          <img v-if="item.coverUrl" :src="item.coverUrl" />
          <div class="list-one">
            <p :title="item.title">{{item.title}}</p>
            <span>{{$service.SmarDateEn(new Date(item.inTime))}}</span>
          </div>
        </div>
      </div>
      <div class="no-msg" v-else>
        No Data！
      </div>
  </div>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "news-list",
  props: {
    hotNewList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
    };
  },
  computed: { 
    genre() {
      return this.$route.query.genre;
    }
  },
  created() {
  },
  methods: {
    linkToNews(item){
      if (this.genre) {
        if (item.link) {
          window.open(item.link,'_blank');
        } else {
          this.$router.push('/news-detailsEn?id=' + item.id + "&genre=host");
        }
      } else {
        this.$router.push('/news-detailsEn?id=' + item.id);
      }
    }
  },
};
</script>

<style scoped lang='scss'>
.list-box{
    background: #fff;
    padding: 20px 20px 0 20px;
    width: 100%;
    .title{
        position: relative;
        margin-bottom: 20px;
        span{
            display: inline-block;
            width: 4px;
            height: 16px;
            background-color: #024c8b;
            position: absolute;
            left: 0;
            top: 0;
        }
        h3{
            display: inline-block;
            font-size: 16px;
            line-height: 18px;
            color: #333;
            margin-left: 15px;
        }
        p{
            position: absolute;
            top: 0;
            right: 0;
            font-size: 14px;
            color: #333;
            cursor: pointer;
        }
    }
    .list-info {
      font-size: 0;
      cursor: pointer;
      padding-bottom: 10px;
      img {
        width: 260px;
        height: 170px;
      }
    }
    .list-one{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 30px;
        p{
            width: 60%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            line-height: 18px;
            color: #333;
        }
        span{
           font-size: 12px;
           color:#666;
        }
    }
    .list-info:hover{
        p{
            color: #024c8b;
        }
    }
}
.no-msg{
    font-size: 14px;
    color: #666;
    text-align: center;
    margin-top: 100px;
}

</style>